module.exports = __webpack_public_path__ + "img/04E8E8_04B5B5_04CCCC_33FCFC-256px.a7c7b3dc.png";